import * as reduxForm from 'redux-form';
import {SET_INSTITUTION} from './institution';

export const SET_POSTAL_CODE = 'gratis-app/SET_POSTAL_CODE';

export default function reducer(state = [], action) {
    switch (action.type) {
        case SET_POSTAL_CODE:
            return action.institutions;
        default:
            return state;
    }
}

export function setPostalCode(postalCode) {

    return (dispatch, getState) => {
        const st = getState();
        dispatch(reduxForm.change('gratisForm', 'institution', ''));
        dispatch(reduxForm.change('gratisForm', 'department', ''));
        dispatch(reduxForm.change('gratisForm', 'departmentName', ''));
        dispatch({
            type: SET_INSTITUTION,
            departments: []
        });
        fetch(`${st.options.ws.base}/api/v1/${st.office.code}/institutions.json?postalCode=${postalCode}`)
            .then(function (response) {
                return response.json();
            })
            .then(function (json) {
                dispatch({
                    type: SET_POSTAL_CODE,
                    institutions: json.institutions || []
                });
            })
            .catch(function (ex) {
                console.log(ex);
            });
    }
}



// WEBPACK FOOTER //
// ./src/form/redux/modules/postalCode.js